<template>
  <section class="saction-wrapper">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: "saction-wrapper"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.saction-wrapper {
  padding: 2rem;

  &.compact {
    padding: 0;
  }

  &.compact-bottom {
    padding-bottom: 0;
  }

  &.compact-top {
    padding-top: 0;
  }
}
</style>
